import { render, staticRenderFns } from "./ExcelPreview.vue?vue&type=template&id=4260101a&scoped=true&"
import script from "./ExcelPreview.vue?vue&type=script&lang=ts&"
export * from "./ExcelPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ExcelPreview.vue?vue&type=style&index=0&id=4260101a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260101a",
  null
  
)

export default component.exports